<script lang="ts">
      let { class: className } = $props()
</script>

<svg class={className} height="auto" viewBox="0 -960 960 960" width="auto" fill="#e3e3e3"><path d="m320.23-107.69-42.54-42.54L607.46-480 277.69-809.77l42.54-42.54L692.54-480 320.23-107.69Z" /></svg>
